import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, int32_type, option_type, lambda_type, unit_type, list_type, tuple_type, class_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { mapIndexed, singleton as singleton_1, ofArray, tryFind, map, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { classNames, logii } from "../../Utils.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { effect } from "../Hooks/ClickOutside.js";
import { fold } from "../../fable_modules/fable-library.3.7.20/Array.js";
import { value as value_3, map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { Prop, CSSProp, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { getMaterialIcon } from "../../ViewUtils.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import "../../../src/Components/StatefulFormFields/SelectOption.scss";


export class SelectOptionProps extends Record {
    constructor(SelectedValue, Options, OnChange, LabelText, ScrollHeightPx) {
        super();
        this.SelectedValue = SelectedValue;
        this.Options = Options;
        this.OnChange = OnChange;
        this.LabelText = LabelText;
        this.ScrollHeightPx = ScrollHeightPx;
    }
}

export function SelectOptionProps$reflection() {
    return record_type("Components.StatefulFormFields.SelectOption.SelectOptionProps", [], SelectOptionProps, () => [["SelectedValue", string_type], ["Options", list_type(tuple_type(string_type, class_type("Fable.React.ReactElement")))], ["OnChange", lambda_type(string_type, unit_type)], ["LabelText", option_type(string_type)], ["ScrollHeightPx", option_type(int32_type)]]);
}

export function SelectOptionProps_get_GetDefault() {
    return new SelectOptionProps("", empty(), (str) => {
        logii(toText(printf("OnChange: %s. Needs override."))(str));
    }, void 0, void 0);
}

export const SelectOption = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_9, children_7, children_11;
    const menuVisibleState = react.useState(false);
    const maxDropDownRowWidthState = react.useState(void 0);
    const refArray = react.useRef([]);
    const options = map((tupledArg) => [tupledArg[0], tupledArg[1]], props.Options);
    const dropdownRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(dropdownRef, () => {
        menuVisibleState[1](false);
    }, void 0))();
        return () => disp.Dispose();
    });
    react.useEffect(() => {
        let newWidth_1, existingWidth_1, newWidth;
        const widthOpt = fold((acc, refElement) => {
            const clientRect = refElement.getBoundingClientRect();
            const width = clientRect.width;
            if (acc != null) {
                const existingWidth = acc;
                if (width > existingWidth) {
                    return width;
                }
                else {
                    return existingWidth;
                }
            }
            else {
                return width;
            }
        }, void 0, refArray.current);
        let newWidthOpt;
        const matchValue = [maxDropDownRowWidthState[0], widthOpt];
        newWidthOpt = ((matchValue[0] == null) ? ((matchValue[1] == null) ? (void 0) : ((newWidth_1 = matchValue[1], newWidth_1))) : ((matchValue[1] == null) ? (void 0) : ((existingWidth_1 = matchValue[0], (newWidth = matchValue[1], (newWidth > existingWidth_1) ? newWidth : (void 0))))));
        if (newWidthOpt != null) {
            const arg_1 = newWidthOpt + 10;
            maxDropDownRowWidthState[1](arg_1);
        }
    }, [props.Options]);
    const selectedElementHtml = defaultArg(map_1((tupledArg_2) => tupledArg_2[1], tryFind((tupledArg_1) => (tupledArg_1[0] === props.SelectedValue), options)), react.createElement("div", {}, ""));
    const dropDownClasses = classNames(ofArray([["select-option__dropdown", true], ["select-option__dropdown--overflow", props.ScrollHeightPx != null], ["invisible", !(menuVisibleState[0])]]));
    const dropDownHtmlProps = toList(delay(() => append(singleton(new HTMLAttr(65, dropDownClasses)), delay(() => {
        let css;
        return (props.ScrollHeightPx != null) ? singleton((css = singleton_1(new CSSProp(248, value_3(props.ScrollHeightPx))), ["style", keyValueList(css, 1)])) : empty_1();
    }))));
    let labelTextHtml;
    const matchValue_1 = props.LabelText;
    if (matchValue_1 != null) {
        const labelText = matchValue_1;
        labelTextHtml = react.createElement("span", {
            className: "select-option__label",
        }, labelText);
    }
    else {
        labelTextHtml = react.createElement(react.Fragment, {});
    }
    const props_14 = toList(delay(() => append(singleton(new HTMLAttr(65, "select-option")), delay(() => append(singleton(new Prop(3, dropdownRef)), delay(() => {
        let css_1;
        return ((maxDropDownRowWidthState[0]) != null) ? singleton((css_1 = singleton_1(new CSSProp(395, value_3(maxDropDownRowWidthState[0]))), ["style", keyValueList(css_1, 1)])) : empty_1();
    }))))));
    const children_13 = [(children_9 = [selectedElementHtml, (children_7 = [getMaterialIcon("expand_more")], react.createElement("span", {
        className: "select-option__chevron",
    }, ...children_7))], react.createElement("div", {
        className: "select-option__selected",
        onClick: (_arg_4) => {
            menuVisibleState[1]((value_2) => (!value_2));
        },
    }, ...children_9)), (children_11 = mapIndexed((i, _arg) => react.createElement("div", {
        className: "dropdown__option",
        ref: (ref) => {
            refArray.current[i] = ref;
        },
        onClick: (_arg_1) => {
            props.OnChange(_arg[0]);
            menuVisibleState[1](false);
        },
    }, _arg[1]), options), react.createElement("div", keyValueList(dropDownHtmlProps, 1), ...children_11)), labelTextHtml];
    return react.createElement("div", keyValueList(props_14, 1), ...children_13);
}, "CustomSelectOption", uncurry(2, void 0), void 0, "SelectOption", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\StatefulFormFields\\SelectOption.fs", 123);

